<sc-auth-page-wrapper
  mainTitle="¿Olvidaste tu contraseña?"
  [subtitle]="subtitle"
  [authAction]="authAction"
>
  <form
    auth-page-wrapper-content
    [formGroup]="form"
    class="text-center">
    <sc-tooltip-input-decorator
      *ngIf="showTooltip"
      [tooltipText]="tooltipText"
      placement="bottom">
        <sc-input
          [maxlength]="userIdMaxLength"
          [pipes]="pipes"
          [errorMessages]="userIdErrorMessages"
          [placeholder]="userIdLabel"
          [label]="userIdLabel"
          [debounceTime]="400"
          autocomplete="off"
          formControlName="userId"
          icon="question-elipse"
          type="text">
        </sc-input>
    </sc-tooltip-input-decorator>
    <sc-input
      *ngIf="!showTooltip"
      [maxlength]="userIdMaxLength"
      [placeholder]="userIdLabel"
      [pipes]="pipes"
      [errorMessages]="userIdErrorMessages"
      [label]="userIdLabel"
      [debounceTime]="400"
      autocomplete="off"
      formControlName="userId"
      type="text"
    ></sc-input>
    <sc-button
      type="primary"
      (onClick)="resetPassword()"
      [loading]="isLoading"
      [disabled]="isLoading || form.invalid"
      id="reset-password">
      Recuperar contraseña
    </sc-button>
    <div>{{mailSentMessage}}</div>
    <sc-auth-error-messages [error]="error"></sc-auth-error-messages>
  </form>
  <div auth-page-wrapper-footer>
    <sc-auth-actions class="footer-action" [authAction]="authAction"></sc-auth-actions>
    <sc-auth-legal-footer></sc-auth-legal-footer>
  </div>
</sc-auth-page-wrapper>
